export default "__VITE_ASSET__BC1Xyz3J__"